exports = module.exports = require("../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".embed-grid-wrapper[data-v-223f1aa2]{width:100%;padding-bottom:10px}", ""]);

// exports
